
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Borivalitopunecab() {



    const cardData =
    {
        keyword: 'Borivali to Pune Cab',
        heading: 'Skyline Cabs: Borivali to Pune Cab ',
        headingDescription: 'Skyline Cabs provides dependable and affordable Borivali to Pune Cab services for a comfortable and worry-free journey. Whether you are traveling for work, a weekend getaway, or airport transfers, our well-maintained vehicles and courteous drivers ensure a safe and relaxing ride. With timely pickups from Borivali, competitive fares, and 24/7 customer support, Skyline Cabs is your trusted partner for intercity travel. Book your Borivali to Pune cab today and enjoy a smooth ride with professional service.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Borivali to Pune Cab Service",
      "description": "Skyline Cabs offers premium cab services from Borivali to Pune, providing a variety of vehicle options including sedans, Ertiga, and Innova Crysta. Enjoy a safe, comfortable, and timely ride with trained drivers and well-maintained vehicles."
    },
    {
      "name": "Borivali to Pune Car",
      "description": "Book a private car from Borivali to Pune with Skyline Cabs. Choose from economical to luxury cars for your journey, ideal for solo travelers, families, or corporate clients looking for comfort and reliability."
    },
    {
      "name": "Borivali to Pune Taxi",
      "description": "Need a taxi from Borivali to Pune? Skyline Cabs provides 24/7 taxi service for one-way and round trips. Our services are perfect for airport transfers, business meetings, or leisure travel, all at transparent rates."
    },
    {
      "name": "Borivali to Pune Taxi Fare",
      "description": "Skyline Cabs ensures transparent and competitive taxi fare from Borivali to Pune. No hidden charges—just clear pricing that includes fuel, tolls, and driver allowance. Contact us for an instant quote."
    },
    {
      "name": "Pune to Borivali Cab",
      "description": "Travel from Pune to Borivali with Skyline Cabs' reliable and safe cab service. We offer door-to-door service, flexible booking options, and a fleet of clean, comfortable vehicles for your convenience."
    },
    {
      "name": "Borivali to Pune Taxi Service",
      "description": "Skyline Cabs provides top-rated taxi services from Borivali to Pune with professional drivers and on-time pickups. Ideal for individuals or groups traveling for business, medical appointments, or family visits."
    },
    {
      "name": "Cab Service in Borivali",
      "description": "Looking for trusted cab services in Borivali? Skyline Cabs provides local, outstation, and airport transfer services with a fleet that includes sedans, SUVs, and 7-seaters. Book online or call us anytime."
    },
    {
      "name": "Taxi Service in Borivali",
      "description": "Skyline Cabs offers reliable taxi service in Borivali for outstation trips, daily travel, or airport transfers. Choose from various car options and enjoy professional service with transparent pricing."
    },
    {
      "name": "Innova Crysta on Rent in Borivali",
      "description": "Rent an Innova Crysta in Borivali for your journey to Pune. Spacious, comfortable, and perfect for families or group travel. Our cabs come with AC, trained drivers, and all safety measures."
    },
    {
      "name": "Borivali to Pune Innova Crysta",
      "description": "Skyline Cabs provides Innova Crysta cabs from Borivali to Pune for travelers looking for space and comfort. Enjoy luxury seating and smooth rides, whether you're traveling for business or leisure."
    },
    {
      "name": "Borivali to Pune Ertiga Cab",
      "description": "For an affordable and spacious ride, book an Ertiga cab from Borivali to Pune with Skyline Cabs. Suitable for small groups or families, offering comfort, safety, and competitive fares."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book your cab from Mumbai to Pune with Skyline Cabs for a seamless and reliable experience. We offer one-way and round-trip options, multiple vehicle choices, and 24/7 customer support."
    },
    {
      "name": "Taxi Service in Borivali for Outstation Trip",
      "description": "Planning an outstation trip from Borivali? Skyline Cabs offers trusted taxi services for long-distance travel. Choose from sedans, Ertiga, or Innova Crysta and enjoy a smooth journey with experienced drivers."
    }
  ],
  "tableData": [
    ["Borivali to Pune Cab Service", "Borivali to Pune Car"],
    ["Borivali to Pune Taxi", "Borivali to Pune Taxi Fare"],
    ["Pune to Borivali Cab", "Borivali to Pune Taxi Service"],
    ["Cab Service in Borivali", "Taxi Service in Borivali"],
    ["Innova Crysta on Rent in Borivali", "Borivali to Pune Innova Crysta"],
    ["Borivali to Pune Ertiga Cab", "Mumbai to Pune Cab Booking"],
    ["Taxi Service in Borivali for Outstation Trip", "Cab Service in Borivali"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Trusted Borivali to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides dependable and on-time cab services from Borivali to Pune. Whether you're traveling for work, a family visit, or a weekend getaway, we ensure a hassle-free, smooth journey with door-to-door convenience and professional service."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet includes sedans, SUVs, and premium cars that are clean, air-conditioned, and designed for long-distance comfort. From solo riders to groups, we have the right vehicle to make your Borivali to Pune journey pleasant and relaxing."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our courteous drivers are well-trained and familiar with the Borivali to Pune route. They prioritize your safety and comfort, choosing the best routes to avoid traffic and ensuring a timely, smooth travel experience with complete professionalism."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "With Skyline Cabs, you get transparent pricing for your Borivali to Pune ride. We offer competitive one-way and round-trip fares with no hidden costs, so you can plan your journey with confidence and clarity."
    },
    {
        "WhyChooseheading": "24/7 Availability from Borivali",
        "WhyChoosedescription": "Skyline Cabs is available anytime you need us. Whether it's a late-night trip or an early morning start, we operate 24/7 to ensure you always have access to a comfortable and reliable cab service from Borivali to Pune."
    },
    {
        "WhyChooseheading": "Multiple Cab Options to Suit Every Need",
        "WhyChoosedescription": "Choose from a range of vehicles based on your travel style and group size. Whether you prefer an economical sedan, a spacious SUV, or a luxury car, we have the right ride to match your preferences for your Borivali to Pune journey."
    },
    {
        "WhyChooseheading": "Easy Booking with Real-Time Updates",
        "WhyChoosedescription": "Booking a cab from Borivali to Pune is quick and easy with our website or mobile app. Get instant confirmations, live driver tracking, and multiple payment options for a seamless and tech-friendly booking experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Intercity Rides",
        "WhyChoosedescription": "Safety comes first at Skyline Cabs. All our vehicles are GPS-enabled, sanitized before every trip, and driven by background-verified professionals. You can relax knowing that your Borivali to Pune cab is as safe as it is comfortable."
    }
]




















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Borivali to Pune with Skyline Cabs?',
            answer:
                'You can book easily through our website or mobile app. Just select Borivali as your pickup location and Pune as your destination, pick your preferred car, and confirm your trip within minutes.',
        },
        {
            id: 2,
            question: 'Do you provide pickup from Borivali East, West, or Railway Station?',
            answer:
                'Yes, we offer pickups from all areas of Borivali, including Borivali East, West, and Railway Station. Just mention your exact location while booking.',
        },
        {
            id: 3,
            question: 'What is the travel time from Borivali to Pune?',
            answer:
                'The journey usually takes around 4 to 5 hours depending on traffic conditions. Our experienced drivers ensure a smooth and safe ride.',
        },
        {
            id: 4,
            question: 'What types of vehicles are available for Borivali to Pune travel?',
            answer:
                'We offer a range of options including Sedans, SUVs, Ertiga, Innova Crysta, and premium vehicles. Choose based on your group size and comfort needs.',
        },
        {
            id: 5,
            question: 'Is the cab fare from Borivali to Pune fixed?',
            answer:
                'Yes, our pricing is fixed and fully transparent. The fare includes tolls, driver charges, and taxes — no hidden costs.',
        },
        {
            id: 6,
            question: 'Do you offer one-way and round-trip options?',
            answer:
                'Absolutely! You can choose between one-way and round-trip bookings. Just select your preference while scheduling your ride.',
        },
        {
            id: 7,
            question: 'Are your drivers experienced for long-distance travel?',
            answer:
                'Yes, all our drivers are trained, background-verified, and experienced in intercity routes. Your safety and comfort are our top priorities.',
        },
        {
            id: 8,
            question: 'Can I get a cab late at night or early in the morning from Borivali?',
            answer:
                'Yes, Skyline Cabs operates 24/7. Whether it’s an early morning departure or a late-night return, we’re ready whenever you are.',
        },
        {
            id: 9,
            question: 'What safety measures are followed during the ride?',
            answer:
                'Our cars are sanitized regularly, equipped with AC, and driven by trained professionals who follow all safety and hygiene protocols.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs from Borivali to Pune?',
            answer:
                'Skyline Cabs provides reliable service, clean and spacious cars, fixed fares, and professional drivers — making your journey from Borivali to Pune seamless and worry-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ritesh Mehra",
            rating: 5,
            review: "Booked a Skyline cab from Borivali West to Pune. The cab arrived on time, was super clean, and the driver knew the route really well. It was a peaceful ride all the way — excellent service!"
        },
        {
            name: "Miss. Swati Jadhav",
            rating: 4,
            review: "I took a one-way trip from Borivali East to Pune. The ride was smooth, the car was comfortable, and the booking process was easy. Would love to see complimentary water bottles in the future!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Borivali to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/borivali-to-pune-cab.jpg",
  "description": "Book Borivali to Pune cabs with Skyline Cabs for a safe, affordable, and comfortable ride. Choose from AC sedans or SUVs with professional drivers — available 24/7 for one-way or round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7774"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/borivali-to-pune-cabs"
  }
};


      
     
      

    return (
        <div>
<Helmet>
  <title>Borivali to Pune Cabs | 24/7 AC Taxi Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Borivali to Pune cabs with Skyline Cabs for a safe, affordable, and comfortable ride. Choose from AC sedans or SUVs with professional drivers — available 24/7 for one-way or round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Borivali to Pune Cabs, Cab from Borivali to Pune, One-Way Taxi Borivali to Pune, Round Trip Cab Borivali to Pune, AC Cab Borivali to Pune, SUV Taxi Borivali to Pune, Affordable Cab Borivali to Pune, Online Cab Booking Borivali to Pune, Skyline Cabs Borivali to Pune, 24/7 Taxi Borivali to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Borivalitopunecab;